<template>
    <table class="table2_default worker no_hover" v-if=isShow>
        <colgroup>
            <col style="width: 150px;">
            <col style="width: 150px;">
            <col style="width: 120px;">
        </colgroup>
        <thead style="z-index: 99;">
            <tr>
                <th>{{ $t('reservationwindow.reservationmonitor.table_outpatient_groupname') }}</th>
                <th>{{ $t('reservationwindow.reservationmonitor.table_outpatient_staffname') }}</th>
                <th>{{ $t('reservationwindow.reservationmonitor.table_outpatient_programname') }}</th>
                <th v-for="(h, index) in parsedHeaders" :key="index">{{ h }}</th>
            </tr>
        </thead>
        <tr v-for="(data, index) in parsedData" :key="index" :class="{'bg_gray': (data.values[0][selectedCountType] == $t('reservationwindow.reservationmonitor.table_subtotal'))}">
            <th class="no_sticky" v-if="data.groupTitle != undefined" :rowspan="data.groupSpan" ><span class="ellipsis" :title="data.groupTitle">{{ data.groupTitle }}</span></th>
            <th class="txt_left" v-if="data.columnTitle != undefined" :rowspan="data.columnSpan">
                <span class="ellipsis" :title="data.columnTitle">
                    <span v-if="data.color != undefined" class="color_circle" :style="'background-color:' +  data.color + ';'"/>
                    {{ data.columnTitle }}
                </span>
            </th>
            <td v-for="(v, index) in data.values" :key="index">{{ v[selectedCountType] }}</td>
        </tr>
    </table>
</template>

<script>
import { monitorState } from '../monitor-popup-state'

const moment = require('@/util/MPMoment')

export default {
    name: 'ReservationPerManagers',
    data() {
        return {
            monitor: monitorState,
        }
    },
    watch: {},
    computed: {
        isShow: function () {
            return this.monitor.selectedPerType == 'managers'
        },
        periodType: function () {
            return this.monitor.selectedPeriod.periodType
        },
        selectedCountType: function () {
            return this.monitor.selectedCountType
        },

        // new columns
        targetDateArray: function() {
            return this.monitor.targetDateArray
        },
        selectedGroups: function() {
            return this.monitor.localGroups.filter(g => g.isSelected == true)
        },
        selectedColumns: function() {
            return this.monitor.localColumns.filter(c => c.isSelected == true)
        },
        parsedHeaders: function() {
            let getWeeksOfMonth = function (date) {
                let startOfMonth = moment(date).startOf('month')
                return Math.ceil((moment(date).date() + startOfMonth.day()) / 7)
            }

            let parsedHeaders = []
            for (let i = 0; i < this.targetDateArray.length; i++) {
                let time = moment(this.targetDateArray[i])
                let value = ''
                if (this.periodType == 'day') {
                    value = time.format(this.$t('reservationwindow.reservationmonitor.label_datedaily'))
                }
                if (this.periodType == 'week') {
                    let date = moment(time).endOf('week')
                    let weeksOfMonth = getWeeksOfMonth(date)
                    const mFormatString = this.$t('reservationwindow.reservationmonitor.table_date_weekly')
                    const wFormatString = this.$t('reservationwindow.reservationmonitor.table_date_weekly_week')
                    value = date.format(mFormatString)
                    value += wFormatString.replace('{n}', weeksOfMonth)
                }
                if (this.periodType == 'month') {
                    value = time.format(this.$t('reservationwindow.reservationmonitor.table_date_monthly'))
                }
                parsedHeaders.push(value)
            }

            return parsedHeaders
        },
        rawData: function() {
            return this.monitor.rawData
        },
        parsedData: function() {
            let parsedDatas = []
            /* 
             * 
             * {
             *      thGroup
             *      thGroupSpan
             *      thColumn
             *      thColumnSpan
             *      tdTitle = program or 소계
             *      raw = []
             * }
             */
            let firstGroupDataIndex = 0
            for (let i=0 ; i<this.selectedGroups.length ; i++) {
                let group = this.selectedGroups[i]
                let groupID = group._id
                let columns = this.selectedColumns.filter(c => c.isSelected && c.groupID == groupID)
                let groupTitle = group.title
                let parsedDataCount = 0
                // let groupSpan = columns.length + 1
                
                for (let j=0 ; j<columns.length ; j++) {
                    let column = columns[j]
                    let columnID = column._id
                    let programs = column.programs
                    let columnTitle = column.title
                    let color = column.color
                    let columnDataIndex = parsedDatas.length
                    
                    for (let k=0 ; k<programs.length ; k++) {
                        let program = programs[k]
                        let programID = program._id
                        let programTitle = program.title

                        let values = [{patients: programTitle, reservations: programTitle}]
                        for (let l=0 ; l<this.targetDateArray.length ; l++) {
                            let startDate = this.targetDateArray[l].startOf('days')
                            let endDate = moment(startDate)
                            if (this.periodType === 'day') {
                                endDate = endDate.add(1, 'days')
                            }
                            if (this.periodType === 'week') {
                                endDate = endDate.add(1, 'weeks')
                            }
                            if (this.periodType === 'month') {
                                endDate = endDate.add(1, 'month')
                            }
                            let rawDatas = this.rawData.filter(d => 
                                    d.groupID == groupID &&
                                    d.columnID._id == columnID &&
                                    d.programID._id == programID &&
                                    (
                                        moment(d.registerDate).isSameOrAfter(startDate) &&
                                        moment(d.registerDate).isBefore(endDate)
                                    )
                                )
                            let patientCount = 0
                            let reservationCount = 0
                            for (let m=0 ; m<rawDatas.length ; m++) {
                                let data = rawDatas[m]
                                patientCount += data.sumHServiceCount
                                reservationCount += data.sumReservationCount
                            }
                            values.push({
                                patients: patientCount,
                                reservations: reservationCount
                            })
                        }
                        
                        let parsedData = {}
                        if (k == 0) {
                            if (j == 0) {
                                parsedData.groupTitle = groupTitle
                            }
                            parsedData.columnTitle = columnTitle
                            parsedData.columnSpan = programs.length + 1
                        }
                        parsedData.color = color
                        parsedData.values = values
                        parsedDatas.push(parsedData)
                        parsedDataCount += 1
                    }

                    // subTotal
                    let sums = []
                    for (let k=0 ; k<this.targetDateArray.length ; k++) {
                        sums.push({ patients: 0, reservations: 0 })
                    }
                    
                    for (let k=columnDataIndex ; k<columnDataIndex + programs.length ; k++) {
                        let data = parsedDatas[k]
                        for (let l=1 ; l<data.values.length ; l++) {
                            sums[l-1].patients += data.values[l].patients
                            sums[l-1].reservations += data.values[l].reservations
                        }
                    }
                    sums.splice(0, 0, {patients: this.$t('reservationwindow.reservationmonitor.table_subtotal'), reservations: this.$t('reservationwindow.reservationmonitor.table_subtotal')})
                    let subTotal = {
                        values: sums
                    }
                    parsedDatas.push(subTotal)
                    parsedDataCount += 1
                }
                let target = parsedDatas[firstGroupDataIndex]
                if (target == undefined) { continue }
                target.groupTitle = groupTitle
                target.groupSpan = parsedDataCount
                firstGroupDataIndex += parsedDataCount
            }

            if (parsedDatas.length == 0) { return parsedDatas }
            // total
            let sums = []
            for (let i=0 ; i<this.targetDateArray.length ; i++) {
                sums.push({ patients: 0, reservations: 0 })
            }
            for (let i=0 ; i<parsedDatas.length ; i++) {
                let data = parsedDatas[i]
                if (data.values[0].patients == this.$t('reservationwindow.reservationmonitor.table_subtotal')) { continue }
                let values = data.values
                for (let j=1 ; j<values.length ; j++) {
                    sums[j-1].patients += values[j].patients
                    sums[j-1].reservations += values[j].reservations
                }
            }
            sums.splice(0, 0, {patients: '-', reservations: '-'})
            let total = {
                groupTitle: this.$t('reservationwindow.reservationmonitor.table_total'),
                groupSpan: 1,
                columnTitle: '-',
                columnSpan: 1,
                values: sums
            }
            parsedDatas.push(total)

            return parsedDatas
        }
    },
    methods: {}
}
</script>
